function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// 国际化时区处理
import { saveTimezoneSvc } from './service';
import { createLogger, isArray, isObject, loadScript } from './utils';
// import momentTimezone from './utils/momentTimezone'
import { staticBaseUrl } from './configs/const';
// const UPDATE_INTERVAL = localStorage.timezoneInterval * 1 || 60 * 60 // 60m
import state from './store';
var TIMEZONE_KEY = 'timezone';
var UPDATE_TIME_KEY = 'timezoneUpdateTime';
var USE_TIMEZONE_ID = true; // timezoneId example: asia/shanghai
var FAILS_KEY = 'timezoneFails';
var FAILS_INTERVAL = 5; // 5S
var MAX_FAIL_TIMES = state.localStorage.timezoneMaxFailTimes || 3; // 最大频繁连续失败次数

var timezone = {
  disabled: false,
  // 是否禁用timezone功能
  isBadToken: false,
  // 是否token无效
  logger: createLogger('i18n-timezone'),
  get updateInterval() {
    return state.localStorage.timezoneInterval * 1 || 60 * 60; // 60m
  },

  get cachedTimezone() {
    return this.getCache(TIMEZONE_KEY);
  },
  get cachedDate() {
    return this.getCache(UPDATE_TIME_KEY);
  },
  getCache: function getCache(key) {
    var cacheVal = state.localStorage.getItem(key);
    var jsonRe = /^\{.*\}$|^\[.*\]$/;
    if (/^\d+$/.test(cacheVal)) {
      cacheVal = cacheVal * 1;
    } else if (jsonRe.test(cacheVal)) {
      try {
        cacheVal = JSON.parse(cacheVal);
      } catch (e) {
        this.logger.errlog('json parse error:', e);
      }
    }
    return cacheVal;
  },
  setCache: function setCache(key, val) {
    if (isArray(val) || isObject(val)) {
      val = JSON.stringify(val);
    }
    return state.localStorage.setItem(key, val);
  },
  checkExpired: function checkExpired() {
    var cachedTS = this.cachedDate || 0;
    var now = new Date().getTime();
    var diff = (now - cachedTS) / 1000; // 秒
    return diff > this.updateInterval;
  },
  checkChanged: function checkChanged() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var cachedVal, curVal;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cachedVal = _this.cachedTimezone;
              _context.next = 3;
              return _this.getValue();
            case 3:
              curVal = _context.sent;
              return _context.abrupt("return", curVal !== cachedVal);
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getDebugTimezone: function getDebugTimezone() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var timezoneIds;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              timezoneIds = [];
              if (window.Intl && window.Intl.DateTimeFormat) {
                timezoneIds[0] = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
              }
              timezoneIds[2] = _this2.getOffset();
              _context2.next = 5;
              return loadScript(staticBaseUrl + "2978daf1/3afbcd35/momentTimezone.min.js", true)["catch"]();
            case 5:
              if (window.momentTimezone) {
                timezoneIds[1] = window.momentTimezone.guess();
              }
              return _context2.abrupt("return", timezoneIds);
            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getId: function getId() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var timezoneId;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              timezoneId = '';
              if (window.Intl && window.Intl.DateTimeFormat) {
                timezoneId = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
              }
              if (timezoneId) {
                _context3.next = 7;
                break;
              }
              _this3.logger.warn('window.Intl.DateTimeFormat Api fail, try moment-timezone');
              _context3.next = 6;
              return loadScript(staticBaseUrl + "2978daf1/3afbcd35/momentTimezone.min.js", true)["catch"](function (err) {
                _this3.logger.errlog('load momentTimezone script fail', err);
              });
            case 6:
              if (window.momentTimezone) {
                timezoneId = window.momentTimezone.guess();
              } else {
                _this3.logger.warn('no window.momentTimezone');
              }
            case 7:
              return _context3.abrupt("return", timezoneId);
            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  getOffset: function getOffset() {
    var date = new Date();
    var offset = date.getTimezoneOffset() * -1 / 60;
    // if (window.sensors) {
    //   window.sensors.track('errorLog', {
    //     logCode: 'timezone_error_offset',
    //     logContent: offset
    //   })
    // }
    return offset; // east for +
  },
  getValue: function getValue() {
    var _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var value;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!USE_TIMEZONE_ID) {
                _context4.next = 6;
                break;
              }
              _context4.next = 3;
              return _this4.getId();
            case 3:
              _context4.t0 = _context4.sent;
              _context4.next = 7;
              break;
            case 6:
              _context4.t0 = _this4.getOffset();
            case 7:
              value = _context4.t0;
              return _context4.abrupt("return", value || _this4.getOffset());
            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  bindEvents: function bindEvents() {
    // beforeunlaod 发起的请求会被cancel
    // window.addEventListener(
    //   'beforeunload',
    //   this.update.bind(this, 'beforeunload')
    // ) // no async job

    if (this.in123Platform()) return;
    window.addEventListener('load', this.update.bind(this, 'load'));
    window.addEventListener('hashchange', this.update.bind(this, 'hashchange'));
    var _history = history,
      pushState = _history.pushState,
      replaceState = _history.replaceState;
    var self = this;
    history.pushState = function () {
      self.logger.log('decorated pushState called');
      self.update('pushState');
      pushState.apply(history, arguments);
    };
    history.replaceState = function () {
      self.logger.log('decorated replaceState called');
      self.update('replaceState');
      replaceState.apply(history, arguments);
    };
  },
  updateFailCallback: function updateFailCallback(now) {
    var _this5 = this;
    var fails = this.getCache(FAILS_KEY) || [];
    fails.push(now);
    this.setCache(FAILS_KEY, fails);
    if (fails.length < MAX_FAIL_TIMES) {
      return;
    }
    var lastFails = fails.slice(-1 * MAX_FAIL_TIMES);
    var isFrequently = lastFails.every(function (fail, i) {
      return i === 0 ? true : fail - lastFails[i - 1] < FAILS_INTERVAL * 1000;
    });
    // 频繁失败，应该是token无效，适当等待
    if (isFrequently) {
      this.isBadToken = true;
      setTimeout(function () {
        _this5.isBadToken = false; // 等待一段时间后，可能token已更新
      }, fails.length * FAILS_INTERVAL * 1000);
    }
  },
  update: function update() {
    // 因为async函数返回promise，作为 beforeunload 的回调，
    // 刷新页面IE会有确认弹窗，所以把doUpdate包装一下
    this.doUpdate.apply(this, arguments);
  },
  in123Platform: function in123Platform() {
    var inside = false;
    if (typeof YXTBOSSPC === 'object') {
      inside = true;
    } else {
      var navEle = document.querySelector('.yxtboss-nav');
      inside = !!navEle;
    }
    if (!this.hasTips123) {
      this.logger.log('in 123 platform?', inside);
      this.hasTips123 = true;
    }
    return inside;
  },
  doUpdate: function doUpdate(event) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var timezone, expired, isChanged, result, now;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(_this6.in123Platform() || _this6.disabled)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.next = 4;
              return _this6.getValue();
            case 4:
              timezone = _context5.sent;
              expired = _this6.checkExpired();
              _context5.next = 8;
              return _this6.checkChanged();
            case 8:
              isChanged = _context5.sent;
              _this6.logger.log("timezone: " + timezone + ", expired: " + expired + ", isChanged: " + isChanged);
              _this6.logger.log("event: " + event + ", update timezone, isUpdating: " + _this6.isUpdating);
              // 同步时区接口需要登录态，没有token 则不调用
              if (state.localStorage.token) {
                _context5.next = 14;
                break;
              }
              _this6.logger.warn('no token, cannot update timezone');
              return _context5.abrupt("return");
            case 14:
              if (!((expired || isChanged) && !_this6.isUpdating && !_this6.isBadToken)) {
                _context5.next = 26;
                break;
              }
              // const timezone = await this.getValue()
              _this6.logger.log('save timezone: ', timezone);
              _this6.isUpdating = true; // 避免频繁触发更新时区
              if (timezone.indexOf('America/Chicago') > -1) {
                timezone = 'Asia/Shanghai';
                if (window.sensors) {
                  _this6.getDebugTimezone().then(function (timezones) {
                    window.sensors.track('errorLog', {
                      logCode: 'timezone_error',
                      logContent: timezones.join(',')
                    });
                  });
                }
              }
              _context5.next = 20;
              return saveTimezoneSvc(timezone);
            case 20:
              result = _context5.sent;
              // 后端没有返回body
              _this6.isUpdating = false;
              now = new Date().getTime();
              if (result !== 'error') {
                _this6.setCache(TIMEZONE_KEY, timezone);
                _this6.setCache(UPDATE_TIME_KEY, now);
                _this6.setCache(FAILS_KEY, []);
                _this6.isBadToken = false;
              } else {
                _this6.updateFailCallback(now);
              }
              _context5.next = 27;
              break;
            case 26:
              _this6.logger.log('timezone not expired or not changed');
            case 27:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  disable: function disable() {
    this.disabled = true;
    this.logger.log('禁用时区');
  },
  enable: function enable() {
    this.disabled = false;
    if (!this.isReady) {
      this.init();
    }
    this.logger.log('启用时区');
  },
  init: function init() {
    // 非客户端浏览器，不处理国际化时区（后期，若node服务需要处理，可拓展并替换'window.'用法）
    if (!state.isBrowser || /exporttoolpdf/.test(window.navigator.userAgent)) return this.logger.log('browser not support timezone!');
    setTimeout(this.doInit.bind(this), 0); // 延时执行，允许使用方按需禁用时区功能
  },
  doInit: function doInit() {
    if (this.disabled) return;
    this.logger.log('start init..');
    if (window.yxtTimezone && window.yxtTimezone.isReady) {
      // 避免被打包到不同的包内，导致重复执行
      this.logger.warn('already initial!');
      return;
    }
    this.isReady = true;
    // window.yxtTimezone = this

    // DOMContentLoaded 可能已经触发，所以监听回调不一定会被执行
    // 如: coreh5 用到 qiankun 回调不会执行

    // document.addEventListener('DOMContentLoaded', () => {
    //   if (this.in123Platform()) { // html未渲染完成 容器class检查会无效
    //     return
    //   }
    //   this.bindEvents()
    // })

    this.bindEvents();

    // 若yxt-i18n是异步chunk方式加载
    // 那么 timezone.init()执行时 DOMContentLoaded 和 load 事件都不会触发
    // 修改时区 刷新页面不容易看到 时间字段的变化, 所以主动update一次
    if (document.readyState === 'complete') {
      this.update();
    }
  }
};

// 客户端浏览器环境，放重复处理
if (state.isBrowser) {
  // 多个地方重复引入，得到相同的对象
  if (!window.yxtTimezone) {
    window.yxtTimezone = timezone;
  } else {
    timezone = window.yxtTimezone;
  }
}
export default timezone;